import React, { useState } from 'react';
import './Contacts.css';
import HeaderMenu from '../Utils/Header';
import Footer from '../Utils/Footer';
import RouteTracker from '../Utils/RouteTracker';

const translations = {
  en: {
    welcome: "Welcome to Kubitu's Imóveis",
    solutions: "Complete solutions for processing, evaluation, and sale of movable and immovable property.",
    aboutUs: "Kubitu's Imóveis is a leading company in the real estate market, headquartered in Paços de Ferreira, dedicated to providing effective and personalized solutions for those looking to buy, sell, or rent properties. With years of experience and a highly qualified team, our mission is to help our clients achieve their dreams by offering excellent service, transparency, and trust. Whether you are looking for your dream home or a good investment opportunity, Kubitu's Imóveis guarantees specialized service and solutions that meet the unique needs of each client.",
    ourValues: "Our Values",
    trust: "Trust: We build lasting relationships with our clients based on honesty and mutual respect.",
    excellence: "Excellence in Service: We value each client and strive to offer a service that exceeds their expectations.",
    innovation: "Innovation: We are always ahead, using the latest tools and technologies to facilitate the real estate process.",
    transparency: "Transparency: We believe that a good deal is only possible when there is clarity at all stages of the negotiation.",
    quality: "Commitment to Quality: We always seek the best options in the market, focusing on quality and satisfaction.",
    contacts: "Contacts",
    email: "Email",
    message: "Message",
    send: "Send",
    phone: "Phone",
    mobile: "Mobile",
    subject: "Subject",
    errorEmail: "Please fill out this field.",
    errorSubject: "Please fill out this field.",
    errorMessage: "Please fill out this field.",
  },
  pt: {
    welcome: "Bem-vindo à Kubitu's Imóveis",
    solutions: "Soluções completas para tramitação, avaliação, e venda de bens móveis e imóveis.",
    aboutUs: "A Kubitu's Imóveis é uma empresa de referência no mercado imobiliário, com sede em Paços de Ferreira, dedicada a proporcionar soluções eficazes e personalizadas para quem pretende comprar, vender ou arrendar imóveis. Com anos de experiência e uma equipa altamente qualificada, a nossa missão é ajudar os nossos clientes a realizar os seus sonhos, oferecendo um serviço de excelência, transparência e confiança. Quer esteja à procura da casa dos seus sonhos ou de uma boa oportunidade de investimento, a Kubitu's Imóveis garante um atendimento especializado e soluções que respondem às necessidades de cada cliente de forma única.",
    ourValues: "Os Nossos Valores",
    trust: "Confiança: Construímos relações duradouras com os nossos clientes, baseadas na honestidade e no respeito mútuo.",
    excellence: "Excelência no Atendimento: Valorizamos cada cliente e esforçamo-nos para oferecer um serviço que ultrapasse as suas expectativas.",
    innovation: "Inovação: Estamos sempre à frente, utilizando as mais modernas ferramentas e tecnologias para facilitar o processo imobiliário.",
    transparency: "Transparência: Acreditamos que um bom negócio só é possível quando há clareza em todas as fases da negociação.",
    quality: "Compromisso com a Qualidade: Procuramos sempre as melhores opções no mercado, com foco na qualidade e satisfação.",
    contacts: "Contactos",
    email: "Email",
    message: "Mensagem",
    send: "Enviar",
    phone: "Telefone",
    mobile: "Telemóvel",
    subject: "Assunto",
    errorEmail: "Por favor preencha este campo.",
    errorSubject: "Por favor preencha este campo.",
    errorMessage: "Por favor preencha este campo.",
  },
  fr: {
    welcome: "Bienvenue chez Kubitu's Imóveis",
    solutions: "Solutions complètes pour le traitement, l'évaluation et la vente de biens mobiliers et immobiliers.",
    aboutUs: "Kubitu's Imóveis est une entreprise de référence sur le marché immobilier, basée à Paços de Ferreira, dédiée à fournir des solutions efficaces et personnalisées à ceux qui souhaitent acheter, vendre ou louer des biens immobiliers. Avec des années d'expérience et une équipe hautement qualifiée, notre mission est d'aider nos clients à réaliser leurs rêves en offrant un service excellent, transparent et de confiance. Que vous recherchiez la maison de vos rêves ou une bonne opportunité d'investissement, Kubitu's Imóveis garantit un service spécialisé et des solutions qui répondent aux besoins uniques de chaque client.",
    ourValues: "Nos Valeurs",
    trust: "Confiance : Nous construisons des relations durables avec nos clients basées sur l'honnêteté et le respect mutuel.",
    excellence: "Excellence du Service : Nous valorisons chaque client et nous efforçons d'offrir un service qui dépasse leurs attentes.",
    innovation: "Innovation : Nous sommes toujours en avance, utilisant les outils et technologies les plus modernes pour faciliter le processus immobilier.",
    transparency: "Transparence : Nous croyons qu'une bonne affaire n'est possible que lorsqu'il y a de la clarté à toutes les étapes de la négociation.",
    quality: "Engagement envers la Qualité : Nous recherchons toujours les meilleures options sur le marché, en nous concentrant sur la qualité et la satisfaction.",
    contacts: "Contacts",
    email: "Email",
    message: "Message",
    send: "Envoyer",
    phone: "Téléphone",
    mobile: "Portable",
    subject: "Sujet",
    errorEmail: "Veuillez remplir ce champ.",
    errorSubject: "Veuillez remplir ce champ.",
    errorMessage: "Veuillez remplir ce champ.",
  },
};

const Contacts = () => {
  const [language, setLanguage] = useState(localStorage.getItem("language") || "pt");
  const t = translations[language];

  React.useEffect(() => {
    const handleLanguageChange = () => {
      setLanguage(localStorage.getItem("language") || "pt");
    };
    window.addEventListener("languageChange", handleLanguageChange);
    return () => window.removeEventListener("languageChange", handleLanguageChange);
  }, []);

  return (
    <>
      <HeaderMenu />
      <RouteTracker />
      <div className="contacts-container">
        {/* Header Section */}
        <header className="contacts-header">
          <h1>{t.welcome}</h1>
          <p>{t.solutions}</p>
        </header>

        {/* Content Section */}
        <section className="contacts-content">
          <h2>{t.aboutUs}</h2>
          <p>{t.ourValues}</p>
          <ul>
            <li>{t.trust}</li>
            <li>{t.excellence}</li>
            <li>{t.innovation}</li>
            <li>{t.transparency}</li>
            <li>{t.quality}</li>
          </ul>

          <h2>{t.contacts}</h2>
          <address>
            <p>{t.phone}: <a href="tel:+351220933677">(+351) 220 933 677</a></p>
            <p>{t.mobile}: <a href="tel:+351919514179">(+351) 919 514 179</a></p>
            <p>Email: <a href="mailto:kubitusimoveis@gmail.com">kubitusimoveis@gmail.com</a></p>
          </address>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Contacts;